import { isEmpty, pickBy } from 'lodash';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import classnames from 'classnames';

// Components:
import SuggestedFilters from 'src/routes/SearchPage/components/Filters/components/FiltersPanel/SuggestedFilters';
import styles from './filterContainer.module.css';
import Container from './components/Container';
import { FILTERS_LIST } from './components/Filters';
import { FiltersClear } from './components/FiltersHelpers/FiltersClear';
import FiltersApplyMobile from './components/mobile/FiltersApply';

// Context:
import { MobileContext } from '../../domain/context/MobileContext';

export const FilterContainer = (props) => {
  const {
    filters,
    touristsCount,
    hasAwaitNewResults,
    sidebarIsHidden,
    changeFilter,
    clearFilter,
    disabled,
    modifierStyles,
    currencyCode,
  } = props;

  const isMobile = useContext(MobileContext);
  const hasFilters = !isEmpty(filters);

  const [rebuildCount, setRebuildCount] = useState(0);
  const containerRef = useRef(null);

  const applySuggestedFilters = useCallback(() => {
    setRebuildCount((currentCount) => currentCount + 1);
  }, []);

  useEffect(() => {
    if (hasAwaitNewResults === false) {
      applySuggestedFilters();
    }
  }, [applySuggestedFilters, hasAwaitNewResults]);

  if (!hasFilters) return null;

  const getFilterData = (Filter) => {
    const { filterName, customFilters } = Filter;
    return filterName && customFilters
      ? pickBy(filters, (val, key) => val && customFilters.indexOf(key) !== -1)
      : filters[filterName];
  };

  const getFilters = () =>
    FILTERS_LIST.map((Filter) => {
      const data = Filter ? getFilterData(Filter) : null;

      if (isEmpty(data)) {
        return null;
      }
      const { filterName } = Filter || {};

      if (filterName === 'flight' && data.direct_flight[0]?.hotel_count === 0)
        return null;

      return Filter ? (
        // @ts-ignore
        <Filter
          // Forcing to remount filters after previous set of filters applied
          key={`filter-${filterName}-${rebuildCount}`}
          onChange={changeFilter}
          className={classnames('filters__filter', styles.filter, {
            [styles.filterMobile]: isMobile,
          })}
          data={data}
          onClear={clearFilter}
          touristsCount={touristsCount}
          isMobile={isMobile}
          currencyCode={currencyCode}
          filterName={filterName}
        />
      ) : null;
    });

  return (
    <div
      className={classnames(styles.container, {
        [styles.containerDisabled]: disabled,
      })}
    >
      <div
        className={classnames(styles.wrapper, {
          [styles.transparent]: isMobile,
          [styles.wrapperBoldTextColor]: !!modifierStyles.boldTextColor,
          [styles.wrapperTextColor]: !!modifierStyles.textColor,
        })}
        style={
          {
            '--boldTextColor': modifierStyles.boldTextColor,
            '--textColor': modifierStyles.textColor,
            '--highlitedBlockColor': modifierStyles.highlitedBlockColor,
          } as React.CSSProperties
        }
        ref={containerRef}
      >
        <Container isMobile={isMobile} isOpen={!sidebarIsHidden}>
          <SuggestedFilters
            className={styles.suggestedFilters}
            isMobile={isMobile}
          />
          <div style={{ paddingBottom: isMobile ? 60 : 0 }}>{getFilters()}</div>
          {isMobile ? (
            <FiltersApplyMobile />
          ) : (
            <FiltersClear className={styles.filtersClear} />
          )}
        </Container>
      </div>
    </div>
  );
};
